import { getValuePaths, type Column } from '@logistiek-zonder-papier/lzp-library'

export function createFlatBaseColumns<T extends object>(
  list: T[],
  excludeKeys: string[],
  options?: {
    searchableKeys?: string[]
    columnOrder?: string[]
    labelOverrides?: Record<string, string>
  }
): Column[] {
  const columns: Column[] = []
  for (const item of list) {
    for (const key of Object.keys(item)) {
      if (columns.some(column => column.key === key) || excludeKeys.includes(key)) {
        continue
      }

      columns.push({
        key,
        label: options?.labelOverrides?.[key] ?? key,
        searchable: options?.searchableKeys?.includes(key) ?? false,
      })
    }
  }

  if (!options?.columnOrder || options.columnOrder.length === 0) {
    return columns
  }

  const ordered = options.columnOrder
    .map(key => columns.find(column => column.key === key))
    .filter((item): item is Column => item !== undefined)

  const remaining = columns.filter(item => !options.columnOrder?.includes(item.key))

  return [...ordered, ...remaining]
}

export function createBaseColumns<T extends Record<string, unknown>>(
  list: T[],
  excludeKeys: RegExp[],
  options?: {
    searchableKeys?: string[]
    columnOrder?: string[]
    labelOverrides?: Record<string, string>
  }
): Column[] {
  const columns: Column[] = []
  for (const item of list) {
    for (const key of getValuePaths(item)) {
      if (
        columns.some(column => column.key === key) ||
        excludeKeys.some(excludeKey => key.match(excludeKey))
      ) {
        continue
      }

      columns.push({
        key,
        label: options?.labelOverrides?.[key] ?? key,
        searchable: options?.searchableKeys?.includes(key) ?? false,
      })
    }
  }

  if (!options?.columnOrder || options.columnOrder.length === 0) {
    return columns
  }

  const ordered = options.columnOrder
    .map(key => columns.find(column => column.key === key))
    .filter((item): item is Column => item !== undefined)

  const remaining = columns.filter(item => !options.columnOrder?.includes(item.key))

  return [...ordered, ...remaining]
}

export function setWeight(weight: number, unit: string): string {
  return weight < 1 ? '' : weight + ' ' + (unit ?? 'ton')
}
